import { useCallback, useMemo } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { decodeFreeTextList, encodeFreeTextList } from 'hooks';

/**
 * The names searched in the creatives list, kept in the `query` URL param (the same name as the list request
 * param). Items are URI-encoded and joined by `;` like the other name filters, so a name with a comma
 * is not split by the router.
 */
const useNameQueryParam = () => {
  const [raw, setRaw] = useQueryParam('query', StringParam);
  const query = useMemo(() => decodeFreeTextList(raw), [raw]);

  const setQuery = useCallback(
    (values: readonly string[]) => {
      const next = encodeFreeTextList(values);
      if (next === (raw ?? undefined)) return;
      setRaw(next, 'replaceIn');
    },
    [raw, setRaw],
  );

  return { query, setQuery };
};

export default useNameQueryParam;
